import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=e0b84d72&scoped=true&"
import script from "./AddProductModal.vue?vue&type=script&lang=js&"
export * from "./AddProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProductModal.vue?vue&type=style&index=0&id=e0b84d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b84d72",
  null
  
)

export default component.exports